import { createReducer } from '@reduxjs/toolkit';
import { AppRoleAssignmentDto, GraphUserDto } from '../../api/msGraphApi';
import { setLoggedEmployeeData, setLoggedEmployeeRoles } from '../actions/employeeActions';
import { Role, findRoleNameBasedOnKey } from '../../api/RoleManagement';

export enum LoginStatus {
    InProgress = 'InProgress',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
}

export interface LoggedEmployeeState {
    basicEmployee: GraphUserDto | null;
    roles: AppRoleAssignmentDto[] | null;
    readableRoles: Role[] | null;

    logginStatus: LoginStatus | null;

    error: string | null;
}

export const loggedEmployeeReducer = createReducer<LoggedEmployeeState>(
    {
        basicEmployee: null,
        roles: null,
        readableRoles: null,
        error: null,
        logginStatus: null,
    },
    (builder) => {
        builder
            .addCase(setLoggedEmployeeData, (state: LoggedEmployeeState, action: any) => {
                const info: GraphUserDto = action.payload;

                state.basicEmployee = info;
            })
            .addCase(setLoggedEmployeeRoles, (state: LoggedEmployeeState, action: any) => {
                const info: AppRoleAssignmentDto[] = action.payload;

                const readableRoles: Role[] = [];

                info.map((role) => {
                    const currRole = findRoleNameBasedOnKey(role.appRoleId ?? '');

                    readableRoles.unshift(currRole);
                });

                state.roles = info;
                state.readableRoles = readableRoles;
            });
    },
);
